import { render, staticRenderFns } from "./OnboardingBanner.vue?vue&type=template&id=97d2124e&scoped=true&"
import script from "./OnboardingBanner.vue?vue&type=script&lang=js&"
export * from "./OnboardingBanner.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingBanner.vue?vue&type=style&index=0&id=97d2124e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d2124e",
  null
  
)

export default component.exports